import { FeatureFunctionalityBuilder } from '@core/shared/feature';
export class FrontendFeatureFunctionalityBuilder extends FeatureFunctionalityBuilder {
  defineMenuItems(menuItems) {
    if (typeof this.config.menuItems !== "undefined") throw new Error("menuItems have already been defined. " + "Currently all menuItems have to be added in one call of defineMenuItems!");
    this.config.menuItems = menuItems;
  }
  defineDynamicComponents(arg) {
    this.mergeIntoConfig('dynamicComponents', arg);
  }
  defineWidgets(arg) {
    this.mergeIntoConfig('widgets', arg);
  }
  defineRootComponents(arg) {
    this.mergeIntoConfig('rootComponents', arg);
  }
  defineItemActions(arg) {
    this.mergeIntoConfig('itemActions', arg);
  }
  defineModelColumns(arg) {
    this.mergeIntoConfig('modelColumns', arg);
  }
  defineModelInstructions(arg) {
    this.mergeIntoConfig('modelInstructions', arg);
  }
  defineRouterLinkRedirects(arg) {
    this.mergeIntoConfig('routerLinkRedirects', arg);
  }
}